import { Controller } from '@hotwired/stimulus';
import breakpoints from '../../bulma/utils/css_breakpoints';
import { toggleAriaExpanded } from '../shared/util/index';

export default class extends Controller {
  static targets = ['sidebar', 'backdrop', 'burgerButton'];

  connect() {
    this.isActive = false;
    this._onResize = () => this.onScreenResize();
    window.addEventListener('resize', this._onResize);
    this.onScreenResize();
  }

  disconnect() {
    window.removeEventListener('resize', this._onResize);
  }

  toggle() {
    if (this.isActive) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    if (this.isActive) {
      return;
    }

    this.isActive = true;
    this.sidebarTarget.classList.add('is-active');
    this.backdropTarget.classList.add('is-active');
    document.body.style.overflow = 'hidden';

    if (this.hasBurgerButtonTarget) {
      toggleAriaExpanded(this.burgerButtonTarget, true);
    }
  }

  close() {
    if (!this.isActive) {
      return;
    }

    this.isActive = false;
    this.sidebarTarget.classList.remove('is-active');
    this.backdropTarget.classList.remove('is-active');
    document.body.style.overflow = '';

    if (this.hasBurgerButtonTarget) {
      toggleAriaExpanded(this.burgerButtonTarget, false);
    }
  }

  onScreenResize() {
    // Close sidebar when resizing beyond touch breakpoint (to desktop)
    if (window.innerWidth > breakpoints.touch) {
      if (this.isActive) {
        this.close();
      }
    }
  }
}
